type Auth0AccessTokenGetter = () => Promise<string | null>;
type Auth0LogoutIfSessionActive = () => void;

let getAuth0AccessTokenImpl: Auth0AccessTokenGetter | null = null;
let logoutAuth0IfSessionActiveImpl: Auth0LogoutIfSessionActive | null = null;

export function setAuth0AccessTokenGetter(getter: Auth0AccessTokenGetter | null) {
  getAuth0AccessTokenImpl = getter;
}

/** Registered from the Auth0 React tree (e.g. Auth0TokenBridge); mirrors Nav manual logout. */
export function setAuth0LogoutIfSessionActive(invoker: Auth0LogoutIfSessionActive | null) {
  logoutAuth0IfSessionActiveImpl = invoker;
}

export function logoutAuth0IfSessionActive() {
  logoutAuth0IfSessionActiveImpl?.();
}

export async function getAuth0AccessToken() {
  if (!getAuth0AccessTokenImpl) {
    return null;
  }

  try {
    return await getAuth0AccessTokenImpl();
  } catch {
    return null;
  }
}
